export default function FloatToCurrencyParser(value: number, currency: string) {
    return value.toLocaleString("en-US", {
        style: "currency",
        currency: currency,
    });
}
